import { FormTemplateQuestionFieldOptionGroupEnum } from 'graphql-common';
import { Values } from '@lib/interfaces/form';

export default function getNewValidityHintConfigKeys(
  validityHintConfig: Values,
  group: FormTemplateQuestionFieldOptionGroupEnum | null,
  lastPosition: number,
) {
  const validityHintConfigKeys = Object.keys(validityHintConfig);
  const newKeysSet: Set<string> = new Set();

  validityHintConfigKeys.forEach((key) => {
    const [rowIndex, columnIndex] = key.split('-').map(Number);

    if (group === FormTemplateQuestionFieldOptionGroupEnum.Rows) {
      newKeysSet.add(`${lastPosition}-${columnIndex}`);
    } else if (group === FormTemplateQuestionFieldOptionGroupEnum.Columns) {
      newKeysSet.add(`${rowIndex}-${lastPosition}`);
    } else {
      newKeysSet.add(`${lastPosition}`);
    }
  });

  return Array.from(newKeysSet);
}
